/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/MRZTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { AccumulatedResultsVerifierConfiguration } from '../frame_accumulation/FrameAccumulationTypes';
import { GenericDocument } from '../generic_document/GenericDocument';
/** @hidden */
export const MrzDocumentTypeValues = [
    'UNKNOWN',
    'CREW_MEMBER_CERTIFICATE',
    'ID_CARD',
    'PASSPORT',
    'VISA',
    'CH_DRIVING_LICENSE',
];
/**
Container for result of MRZ scanning attempt.
*/
export class MrzScannerResult {
    /** @param source {@displayType `DeepPartial<MrzScannerResult>`} */
    constructor(source = {}) {
        /**
          Scanning successful.
          
          Default is false
          */
        this.success = false;
        this._released = false;
        if (source.success !== undefined) {
            this.success = source.success;
        }
        if (source.rawMRZ !== undefined) {
            this.rawMRZ = source.rawMRZ;
        }
        else {
            throw new Error('rawMRZ must be present in constructor argument');
        }
        if (source.document !== undefined) {
            this.document = source.document != null ? new GenericDocument(source.document) : null;
        }
        else {
            throw new Error('document must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            success: this.success,
            rawMRZ: this.rawMRZ,
            document: this.document != null ? await this.document.serialize(config) : null,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.document != null) {
                this.document.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.document != null) {
            await this.document.encodeImages();
        }
    }
}
/** @hidden */
export const MrzIncompleteResultHandlingValues = ['ACCEPT', 'REJECT'];
/**
Configuration for MRZ scanner.
*/
export class MrzScannerConfiguration {
    /** @param source {@displayType `DeepPartial<MrzScannerConfiguration>`} */
    constructor(source = {}) {
        /**
          Configure the frame accumulation process.
          */
        this.frameAccumulationConfiguration = new AccumulatedResultsVerifierConfiguration({});
        /**
          Enable MRZ detection. If disabled, the scanner skips the detection step and assumes that the input image is a crop of the MRZ area.
          
          Default is true
          */
        this.enableDetection = true;
        /**
          Defines how to handle incomplete MRZ results (e.g. caused by failed validation).
          
          Default is REJECT
          */
        this.incompleteResultHandling = 'REJECT';
        /**
          If true, crops of the detected MRZ and its fields will be returned in the result.
          
          Default is false
          */
        this.returnCrops = false;
        /**
          Scanners typically can produce better results from a single image if they are allowed to spend a longer time analyzing it.
          
          On the other hand, scanners can produce even better results if they can analyze multiple images of the same subject and cross-check and combine the results.
          The processing mode tells the scanner whether to optimize for single or multiple images of a subject.
          
          Default is AUTO
          */
        this.processingMode = 'AUTO';
        if (source.frameAccumulationConfiguration !== undefined) {
            this.frameAccumulationConfiguration = new AccumulatedResultsVerifierConfiguration(source.frameAccumulationConfiguration);
        }
        if (source.enableDetection !== undefined) {
            this.enableDetection = source.enableDetection;
        }
        if (source.incompleteResultHandling !== undefined) {
            this.incompleteResultHandling = source.incompleteResultHandling;
        }
        if (source.returnCrops !== undefined) {
            this.returnCrops = source.returnCrops;
        }
        if (source.processingMode !== undefined) {
            this.processingMode = source.processingMode;
        }
    }
}
/**
Configuration for MRZ parser.
*/
export class MrzParserConfiguration {
    /** @param source {@displayType `DeepPartial<MrzParserConfiguration>`} */
    constructor(source = {}) {
        /**
          Defines how to handle incomplete MRZ results (e.g. caused by failed validation).
          
          Default is ACCEPT
          */
        this.incompleteResultHandling = 'ACCEPT';
        if (source.incompleteResultHandling !== undefined) {
            this.incompleteResultHandling = source.incompleteResultHandling;
        }
    }
}
//# sourceMappingURL=MrzTypes.js.map